import React from "react";
var __jsx = React.createElement;
import { faXmark } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import AwesomeIcon from "../../AwesomeIcon";
import { t } from "i18next";
function ModalHeader(_ref) {
  var activeTab = _ref.activeTab,
    tabs = _ref.tabs,
    onClose = _ref.onClose,
    onTabChange = _ref.onTabChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-gray-800 rounded-t-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between px-6 pt-5 pb-5 border-b border-gray-700"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "text-lg font-medium text-gray-900 dark:text-gray-100 "
  }, t("label.link_patient_records")), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "text-gray-900 dark:text-gray-100 hover:opacity-70 transition-opacity",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "xl"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex border-t border-gray-200 dark:border-gray-800"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("button", {
      key: tab.id,
      onClick: function onClick() {
        return onTabChange(tab.id);
      },
      className: classNames("flex-1 flex items-center justify-center gap-1 h-[48px] text-base font-medium transition-colors", {
        "border-b-4 border-teal-400 dark:border-teal-500 bg-gray-100 dark:bg-gray-900": activeTab === tab.id,
        "border-b-4 border-transparent hover:bg-gray-100 dark:hover:bg-gray-900": activeTab !== tab.id
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-gray-900 dark:text-gray-100"
    }, tab.label), /*#__PURE__*/React.createElement("span", {
      className: "text-gray-400 dark:text-gray-600"
    }, "(", tab.count, ")"));
  })));
}
export default ModalHeader;